<template>
  <div class="change_address_block col-lg-6 col-md-8 col-12">
    <div class="row">
      <div class="col-lg-6 col-12">
        <label for="con_office" class="col-form-label">
          {{ $helper.trans('Receiver') }}: *
        </label>
        <input v-model="form.con_office" type="text" class="input-big">
        <span v-if="errors.con_office" class="error-message">{{ errors.con_office[0] }}</span>
      </div>
      <div class="col-lg-6 col-12">
        <label for="con_address" class="col-form-label">
          {{ $helper.trans('Address') }}: *
        </label>
        <input v-model="form.con_address" type="text" class="input-big">
        <span v-if="errors.con_address" class="error-message">{{ errors.con_address[0] }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-12">
        <label for="con_office" class="col-form-label">
          {{ $helper.trans('City') }}: *
        </label>
        <input v-model="form.con_city" type="text" class="input-big">
        <span v-if="errors.con_city" class="error-message">{{ errors.con_city[0] }}</span>
      </div>
      <div class="col-lg-6 col-12">
        <label for="con_address" class="col-form-label">
          {{ $helper.trans('Post_code') }}: *
        </label>
        <input v-model="form.con_post" type="text" class="input-big">
        <span v-if="errors.con_post" class="error-message">{{ errors.con_post[0] }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-12">
        <label for="con_office" class="col-form-label">
          {{ $helper.trans('Contact_person') }}: *
        </label>
        <input v-model="form.con_name" type="text" class="input-big">
        <span v-if="errors.con_name" class="error-message">{{ errors.con_name[0] }}</span>
      </div>
      <div class="col-lg-6 col-12">
        <label for="con_address" class="col-form-label">
          {{ $helper.trans('Phone') }}: *
        </label>
        <input v-model="form.con_phone" type="text" class="input-big">
        <span v-if="errors.con_phone" class="error-message">{{ errors.con_phone[0] }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="option-column datepicker-container">
          <label for="change_address_datepicker" class="col-form-label">
            {{ $helper.trans('Desired_delivery_date') }}: *
          </label>
          <input
              v-model="form.new_date"
              id="change_address_datepicker"
              type="text"
              class="input-big"
              :data-custom-datepicker-settings="JSON.stringify(datepickerCustomSettings)"
              @change="(val) => form.new_date = val"
          >
          <span v-if="errors.new_date" class="error-message">{{ errors.new_date[0] }}</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label class="col-form-label">
          {{ $helper.trans('Remarks') }}:
        </label>
        <textarea v-model="form.remarks" cols="50" rows="10"></textarea>
        <span v-if="errors.remarks" class="error-message">{{ errors.remarks[0] }}</span>
      </div>
    </div>
    <div v-if="$helper.trans('Change_address_bottom_message') !== '--'" class="text-center text-danger mt-2">
      {{ $helper.trans('Change_address_bottom_message') }}
    </div>

    <div class="text-center mt-2">
      <button type="button" class="btn btn-yellow" @click="saveData">{{ $helper.trans('Save') }}</button>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      form: {
        con_office: '',
        con_address: '',
        con_city: '',
        con_post: '',
        con_name: '',
        con_phone: '',
        new_date: '',
        remarks: '',
      },
      datepickerCustomSettings: {
        minDate: '',
        noWeekends: true,
      },
    }
  },
  props: {
    holidays: {
      required: true,
      type: Array,
      default: [],
    },
    errors: {
      type: Object,
      required: false,
      default: {},
    },
  },
  mounted: function () {
    const currentTime = moment().format('Hmm')
    if (currentTime > 930) {
      this.datepickerCustomSettings.minDate = moment().add(1, 'days').format('YYYY-MM-DD');
    } else {
      this.datepickerCustomSettings.minDate = moment().format('YYYY-MM-DD');
    }
    this.datepickerCustomSettings.holidays = this.holidays
    this.$nextTick(() => {
      const datepickerInput = $('#change_address_datepicker')
      datepickerInput.on('change', (event) => {
        let newDate = moment($(event.target).val())

        while (
            newDate.isoWeekday() >= 6
            || this.holidays.some((holidayDate) => {
                return moment(holidayDate).isSame(newDate, 'day');
              })
            ) {
          newDate.add(1, 'day');
        }

        this.form.new_date = newDate.format('YYYY-MM-DD')
      });
      window.initDatePicker(datepickerInput);
    });
  },
  methods: {
    saveData() {
      const data = {
        opened_box: 1,
        ...this.form,
      }

      this.$emit('save', data)
    }
  }
}
</script>

